export default __webpack_public_path__ + "static/media/actions-xdai.8ccc66c1.svg";